import {useState} from 'react'

import {Props} from './PaymentCardAdd.types'

export function usePaymentCardAdd({onAdd}: Props) {
  const [opened, setOpened] = useState<boolean>(false)
  const openHandler = setOpened.bind(null, true)
  const closeHandler = setOpened.bind(null, false)

  function successHandler() {
    closeHandler()
    onAdd?.()
  }

  return {
    opened,
    openHandler,
    closeHandler,
    successHandler,
  } as const
}
